import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    notTracked: translate({
      id: 'form.drivers.tooltip.notTracked',
    }),
  }))

  return api
}
